import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso} from '@gull'
import axios from 'axios'
import apiCallCompta_correspondance from './Comp/apiCallCompta_correspondance'
import SubmitAndSelectTypeCorrespondence from './Comp/SubmitAndSelectTypeCorrespondence'

const CodeConfigurationDeposit = (props) => {
    const t = useTranslate();
    const [correspondenceModePayDepositValue,setCorrespondenceModePayDepositValue] = useState({})
    const [correspondenceDebitCreditDepositValue,setCorrespondenceDebitCreditDepositValue] = useState({})
    const [disabledBtn,setDisabledBtn] = useState(false)
    const [validButton,setValidButton] = useState(false)

    useEffect(function () {
        if(props.detailConfig && props.detailConfig.type==props.selectType){
            let obj = {}
            let objDebitCredit = {}

            props.allModePayAcompte.map(value=>{
                if(value=='debit' || value=='credit'){
                    objDebitCredit[value] = {
                        numero: (props.detailConfig && props.detailConfig.acompte!=null && props.detailConfig.acompte[value]) ? props.detailConfig.acompte[value].numero : '',
                        libelle: (props.detailConfig && props.detailConfig.acompte!=null && props.detailConfig.acompte[value]) ? props.detailConfig.acompte[value].libelle : ''
                    }
                }else{
                    obj[value] = (props.detailConfig && props.detailConfig.acompte!=null && props.detailConfig.acompte.config[value]) ? props.detailConfig.acompte.config[value] : ''
                }
            })
            
            setCorrespondenceModePayDepositValue(obj)
            setCorrespondenceDebitCreditDepositValue(objDebitCredit)
        }
    }, [props.detailConfig])

    useEffect(function () {
        if(Object.keys(correspondenceModePayDepositValue).length!=0){
            setDisabledBtn(false)
            let initDisabled = false

            Object.entries(correspondenceDebitCreditDepositValue).map(([modePay,value])=>{
                if(value.numero=='' || value.libelle=='') initDisabled=true
            })

            if(!initDisabled){
                Object.entries(correspondenceModePayDepositValue).map(([modePay,value])=>{
                    if(value=='') initDisabled=true
                })
            }
            
            setDisabledBtn(initDisabled)
        }
    }, [correspondenceModePayDepositValue,correspondenceDebitCreditDepositValue])


    const handleChange = (e,modePay,isFor) => {
        if(isFor=='code'){
            setCorrespondenceModePayDepositValue({...correspondenceModePayDepositValue,[modePay]:e.target.value})
        }else{
            //isFor est égale soit à numero, soit libelle
            setCorrespondenceDebitCreditDepositValue({
                ...correspondenceDebitCreditDepositValue,
                [modePay]:{
                    ...correspondenceDebitCreditDepositValue[modePay],
                    [isFor]:e.target.value
                }
            })
        }
        
    };

    const handleSubmit = () => {    
        let axiosAction = props.detailConfig ? axios.put : axios.post
        let configId = props.detailConfig ? '/'+props.detailConfig.id : ''
        let acompte_obj = {...correspondenceDebitCreditDepositValue}
        let config_acompte_obj = {}

        Object.entries(correspondenceModePayDepositValue).map(([modePay,valueInput])=>{
            config_acompte_obj[modePay] = valueInput
        })

        if(props.selectType=='vente_b2c') acompte_obj['config'] = config_acompte_obj

        let obj = {
            acompte: acompte_obj,
            type:props.selectType
        }
        if(props.idCompany!='company') obj["other_company"]=props.idCompany
        
        apiCallCompta_correspondance(setValidButton,axiosAction,obj,t,configId,props.setReload)
    };

    return(<>
        <SubmitAndSelectTypeCorrespondence
            disabledBtn={disabledBtn}
            validButton={validButton}
            handleSubmit={handleSubmit}
            selectType={props.selectType}
            setSelectType={props.setSelectType}

            idCompany={props.idCompany}
            config={props.config}
            setReload={props.setReload}
            company={props.company}
        />
        <div className='row'>
            {props.allModePayAcompte.map(value=>{
                if(value=='debit' || value=='credit'){
                    return(
                        <div key={value} className="col-6">
                            <CardPerso header={t(value) ? t(value) : value}>
                                <div className="row">
                                    <div className="col-6 form-group">
                                        <label>Code</label>
                                        <input 
                                            disabled={validButton}
                                            value={correspondenceDebitCreditDepositValue[value]?.numero || ''} 
                                            type="text" 
                                            className='form-control' 
                                            onChange={(e)=>handleChange(e,value,'numero')} 
                                        />
                                    </div>
                                    <div className="col-6 form-group">
                                        <label>{t('wording')}</label>
                                        <input 
                                            disabled={validButton}
                                            value={correspondenceDebitCreditDepositValue[value]?.libelle || ''} 
                                            type="text" 
                                            className='form-control' 
                                            onChange={(e)=>handleChange(e,value,'libelle')} 
                                        />
                                    </div>
                                </div>
                            </CardPerso>
                        </div>
                    )
                }
            })}
        </div>
        {(props.allModePayAcompte.length > 2) &&
            <>
                <div className='col alert alert-info mb-4'>{t('libelleAttribueAcompte')}</div>
                <div className='row'>
                    {props.allModePayAcompte.map(value=>{
                        if(value!='debit' && value!='credit'){
                            return(
                                <div key={value} className="col-4">
                                    <CardPerso header={t(value) ? t(value) : value}>
                                        <div className="row">
                                            <div className="col-12 form-group">
                                                <label>Code</label>
                                                <input 
                                                    disabled={validButton}
                                                    value={correspondenceModePayDepositValue?.[value] || ''} 
                                                    type="text" 
                                                    className='form-control' 
                                                    onChange={(e)=>handleChange(e,value,'code')} 
                                                />
                                            </div>
                                        </div>
                                    </CardPerso>
                                </div>
                            )
                        }
                    })}
                </div>
            </>
        }
    </>
    )
}

export default CodeConfigurationDeposit;